var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon29BlogMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2a2 2 0 0 0-2 2v6.98a2 2 0 0 0 1 1.73l3.62 2.08a4 4 0 1 0 4.76 0L18 12.7a2 2 0 0 0 1-1.73V4a2 2 0 0 0-2-2H7zm0 8.98V4h2v8.12l-2-1.14zm4 2.3V4h2v9.27l-1 .58-1-.58zm4-1.16 2-1.14V4h-2v8.12zM10 18a2 2 0 1 0 4 0 2 2 0 0 0-4 0z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik03IDJhMiAyIDAgMCAwLTIgMnY2Ljk4YTIgMiAwIDAgMCAxIDEuNzNsMy42MiAyLjA4YTQgNCAwIDEgMCA0Ljc2IDBMMTggMTIuN2EyIDIgMCAwIDAgMS0xLjczVjRhMiAyIDAgMCAwLTItMkg3em0wIDguOThWNGgydjguMTJsLTItMS4xNHptNCAyLjNWNGgydjkuMjdsLTEgLjU4LTEtLjU4em00LTEuMTYgMi0xLjE0VjRoLTJ2OC4xMnpNMTAgMThhMiAyIDAgMSAwIDQgMCAyIDIgMCAwIDAtNCAweiIgZmlsbC1ydWxlPSJldmVub2RkIi8+DQo8L3N2Zz4NCg==";
export { SvgIcon29BlogMedal as ReactComponent };